import storage from 'redux-persist/lib/storage';

import { apiCredentials } from './apiManager';
import { extractAccount } from './usersDataManager';
import { refreshToken, logout } from 'store/accountActions';
import { apiUsersUrls } from 'config/endPoints';

const PERSIST_ACCOUNT_KEY = 'seinetcore-issuer-account';

let _dispatch = null;
let _getState = null;
let _refreshPromise = null;

export const initBaseManager = (store) => {
    _dispatch = store.dispatch;
    _getState = store.getState;
};

export const getState = () => _getState?.();

export const dispatch = (action) => _dispatch?.(action);

export const logoutAndPurge = () => {
    _dispatch?.(logout());
    storage.removeItem(PERSIST_ACCOUNT_KEY);
};

export const refreshTokenOnce = () => {
    if (_refreshPromise) return _refreshPromise;

    _refreshPromise = apiCredentials
        .post(apiUsersUrls.API_REFRESH_TOKEN_URL)
        .then((response) => {
            const user = extractAccount(response.data);
            _dispatch(refreshToken(user));
            return user;
        })
        .finally(() => {
            _refreshPromise = null;
        });

    return _refreshPromise;
};
